/*
  Product Footer Accordion (by Aaron)
  Controla el acordeón inferior del producto sin interferir con el tema Warehouse.
*/

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.pf-accordion__btn');

  if (!accordions.length) return;

  accordions.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();

      const item = btn.closest('.pf-accordion__item');
      const content = item.querySelector('.pf-accordion__content');
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      // Cerrar todos los demás
      document.querySelectorAll('.pf-accordion__item.open').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('open');
          openItem.querySelector('.pf-accordion__content')?.setAttribute('hidden', '');
          openItem.querySelector('.pf-accordion__btn')?.setAttribute('aria-expanded', 'false');
        }
      });

      // Alternar el actual
      btn.setAttribute('aria-expanded', String(!isExpanded));
      if (isExpanded) {
        content.setAttribute('hidden', '');
        item.classList.remove('open');
      } else {
        content.removeAttribute('hidden');
        item.classList.add('open');
      }
    });
  });
});
